module.exports = __webpack_public_path__ + "media/images/loading-792777f095784dcad641ae875b13aa7c.gif";